// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__ux0mZ","heading":"styles_heading__tUmLl","text":"styles_text__TeE2T"};